module.exports = __webpack_public_path__ + "static/media/au.497744bf.svg";